import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let UpIcon = class UpIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = '24';
    }
    render() {
        const stroke = this.color ? getIconColorSVGFill(this.color) : 'currentColor';
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 12L12 4"
          stroke=${stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4H12V10"
          stroke=${stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    `;
    }
};
UpIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], UpIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], UpIcon.prototype, "size", void 0);
UpIcon = __decorate([
    customElement('up-icon')
], UpIcon);
var UpIcon$1 = UpIcon;

export { UpIcon$1 as default };
//# sourceMappingURL=upIcon.js.map
